import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { trackAI } from './telemetryHelper';

export const REQUEST_TIMEOUT = 30000;

export async function fetchWithTimeout(input: RequestInfo, init: RequestInit & { timeout?: number } = {}) {
  const { timeout = REQUEST_TIMEOUT, ...rest } = init;
  const controller = new AbortController();

  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await fetch(input, { ...rest, signal: controller.signal });
    return res;
  } catch (err: unknown) {
    const msg = err instanceof Error ? err.message : String(err);
    trackAI(`Fetch error calling '${typeof input === 'string' ? input : ''}': ${msg}`, SeverityLevel.Error);
    throw err;
  } finally {
    clearTimeout(id);
  }
}

export async function fetchJsonWithTimeout<T>(
  input: RequestInfo,
  init: RequestInit & { timeout?: number } = {},
): Promise<T> {
  const res = await fetchWithTimeout(input, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init.headers ?? {}),
    },
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${res.statusText}`);
  }

  return await res.json();
}
